import { FC } from 'react'
import cn from 'classnames'
import WazzupIcon from '@pages/Admin/CRM/components/PhoneIntegrationButtons/WazzupIcon'
import { getWazzupChannelTypeLabel } from './wazzupCrmIntegration.helpers'
import { formatWazzupChannelAriaLabel } from './WazzupChannelTypeMark'
import classes from './wazzupSourceBadge.module.css'

type WazzupSourceBadgeProps = {
  type?: string | null
  className?: string
}

/** Компактно: лого Wazzup + тип канала (без второй «брендовой» иконки). */
export const WazzupSourceBadge: FC<WazzupSourceBadgeProps> = ({
  type,
  className,
}) => {
  const typeLabel = getWazzupChannelTypeLabel(String(type ?? ''))
  const showType = typeLabel && typeLabel !== 'неизвестный'

  return (
    <span
      className={cn(classes.badge, className)}
      title={formatWazzupChannelAriaLabel(type)}
    >
      <WazzupIcon className={classes.logo} />
      {showType ? (
        <span className={classes.type}>{typeLabel}</span>
      ) : (
        <span className={classes.type}>Wazzup</span>
      )}
    </span>
  )
}

export default WazzupSourceBadge
